module.exports = __webpack_public_path__ + "img/2.26b337ae.jpg";